// require("babel-polyfill") afegit per mi
require("babel-polyfill");
const staticMethods = require('./lib/static-methods');
const instanceMethods = require('./lib/instance-methods');

module.exports = Object.assign(staticMethods, { instanceMethods });



// WEBPACK FOOTER //
// ./~/p-iteration/index.js